<template>
  <section class="relative px-4 py-20 text-center sm:px-8 lg:px-16 xl:px-40 2xl:px-64">
    <div class="container mx-auto">
      <!-- Start Title -->
      <div class="py-8">
        <div class="mx-auto text-center lg:w-4/6">
          <h2 class="text-2xl md:text-4xl"><strong>Klienci</strong> Powiedzieli O Nas...</h2>
        </div>
      </div>
      <!-- End Title -->

      <!-- Start Testmonials  -->
      <!-- End Testimonial -->
    </div>
    <!-- End Testimonial  -->

    <!-- Start Image -->
    <div class="flex py-8 text-center">
      <img
        data-src="img/drawing-friends.png"
        class="w-32 mx-auto lazy loaded"
        alt="Drawing Friends"
        data-ll-status="loaded"
        src="../../client/assets/logo-haft.png"
      />
    </div>
    <!-- End Image -->

    <!-- Start Testimonial  -->
    <div class="flex flex-col text-center md:flex-row">
      <!-- Start Testimonial -->
      <div class="flex flex-col my-4 md:w-1/3 lg:my-0 md:px-4">
        <blockquote class="order-first text-lg italic text-gray-700 md:text-md lg:text-lg lg:order-last">
          Szybko, sprawnie i zawsze na czas. Dzięki świadczonym usługom, każdego dnia tysiące zawodników klubu może brać
          udział w treningach w oryginalnych strojach oznakowanych herbem Akademii.
        </blockquote>
        <div class="flex items-center content-center justify-center order-last mt-3 lg:order-first">
          <img
            data-src="../../assets/img/logotypy/akademia-piotra-reissa-logo.png"
            class="self-start lazy loaded"
            alt="Testimonial Avatar"
            data-ll-status="loaded"
            src="../../assets/img/logotypy/akademia-piotra-reissa-logo.png"
          />
          <!-- Generate free faces via: https://generated.photos/faces -->
          <span class="ml-2 font-bold text-gray-900 md:text-lg">Akademia Piłkarska Reissa</span>
        </div>
      </div>
      <!-- End Testimonial -->

      <!-- Start Testimonial -->
      <div class="flex flex-col my-4 md:w-1/3 lg:my-0 md:px-4">
        <blockquote class="order-first text-lg italic text-gray-700 md:text-md lg:text-lg lg:order-last">
          Współpracujemy już prawie 5 lat. Wciąż rozwijają park maszynowy i metody znakowania odzieży, ale przede
          wszystkim są terminowi i jest między nami dobra komunikacja.
        </blockquote>
        <div class="flex items-center content-center justify-center order-last mt-3 lg:order-first">
          <img
            data-src="../../assets/img/logotypy/sand-logo.png"
            class="self-start lazy loaded"
            alt="Testimonial Avatar"
            data-ll-status="loaded"
            src="../../assets/img/logotypy/sand-logo.png"
          />
          <!-- Generate free faces via: https://generated.photos/faces -->
          <span class="ml-2 text-lg font-bold text-gray-900 md:text-lg">Sand</span>
        </div>
      </div>
      <!-- End Testimonial -->
      <div class="flex flex-col my-4 md:w-1/3 lg:my-0 md:px-4">
        <blockquote class="order-first text-lg italic text-gray-700 md:text-md lg:text-lg lg:order-last">
          Chwalimy sobie współpracę z Hafciarnią od samego początku. Wysoka jakość haftów i profesjonalna obsługa.
          Polecamy.
        </blockquote>

        <div class="flex items-center content-center justify-center order-last mt-3 lg:order-first">
          <img
            data-src="../../assets/img/logotypy/66projekt-logo.png"
            class="self-start lazy loaded"
            alt="Testimonial Avatar"
            data-ll-status="loaded"
            src="../../assets/img/logotypy/66projekt-logo.png"
          />
          <!-- Generate free faces via: https://generated.photos/faces -->
          <span class="ml-2 font-bold text-gray-900 md:text-lg">66 Projekt</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Testimonials",
};
</script>

<style scoped></style>
